/*
 * -----------------------------------------------------------------------
 *  <copyright file="add-library-control/text-field.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import cn from 'clsx';
import CharactersRemaining from '../../core/characters-remaining';
import TextField from '../../core/text-field';
import { AddLibraryControlFieldProps } from './add-library-control.interface';

interface AddLibraryControlTextFieldProps extends AddLibraryControlFieldProps {
    label: string;
    id: string;
    fieldName: string;
    placeholder: string;
    error: string;
}

const AddLibraryControlTextField = ({
    state,
    onChange,
    className,
    label,
    id,
    fieldName,
    placeholder,
    error,
}: AddLibraryControlTextFieldProps) => (
    <TextField
        label={label}
        id={id}
        multiline
        rows={5}
        fullWidth
        value={state[fieldName]}
        onChange={onChange}
        placeholder={placeholder}
        helperText={
            <CharactersRemaining
                id={`add-library-control-dialog-${fieldName}`}
                length={state[fieldName]?.length}
                max={3000}
                error={error}
            />
        }
        variant="outlined"
        color="secondary"
        className={cn('mb', className)}
        error={!!error}
    />
);

export default AddLibraryControlTextField;
